import { AppIconsFlatWeaving, AppIconsHeatSettings, AppIconsMachineryWinding } from "../../../../components/AppIcons";
import { useClasses } from "../InstalledBaseAccordion/InstalledBaseAccordion.styles";


type TRenderBusinessUnitIcon = {
    status: string;
}

export default function RenderBusinessUnitIcon(props: TRenderBusinessUnitIcon) {

    const classes = useClasses();
    
    switch (props.status) {
        case "Spinning Machine":
            return <AppIconsMachineryWinding sx={classes.iconSize} />;
        case "Weaving Hall":
            return <AppIconsFlatWeaving sx={classes.iconSize} />;
        case "Heat setting Treatment":
            return <AppIconsHeatSettings sx={classes.iconSize} />;
        default:
            return <></>;
    }
}
